// components/TawkChat.tsx — REPLACE your existing file with this
"use client";
import { useEffect } from "react";
import { usePathname } from "next/navigation";

export default function TawkChat() {
  const pathname = usePathname();
  const isDashboard = pathname.startsWith("/dashboard");

  // Load the script ONCE (only on first non-dashboard visit)
  useEffect(() => {
    if (isDashboard) return;
    if ((window as any).__tawkScriptLoaded) return;

    const timer = setTimeout(() => {
      (window as any).Tawk_API = (window as any).Tawk_API || {};

      // Force-minimize on load
      (window as any).Tawk_API.onLoad = function () {
        (window as any).Tawk_API.minimize();
      };

      // Force-minimize the INSTANT anything tries to maximize it
      // (this is what stops the auto-popup/greeting bubble from expanding)
      (window as any).Tawk_API.onChatMaximized = function () {
        (window as any).Tawk_API.minimize();
      };

      var s1 = document.createElement("script");
      var s0 = document.getElementsByTagName("script")[0];
      s1.async = true;
      s1.src = "https://embed.tawk.to/6a2aa4fe1ed8571c31519871/1jqr9911b";
      s1.charset = "UTF-8";
      s1.setAttribute("crossorigin", "*");
      s0.parentNode!.insertBefore(s1, s0);
      (window as any).__tawkScriptLoaded = true;
    }, 5000);

    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Actively show/hide the widget every time the route changes
  useEffect(() => {
    const applyVisibility = () => {
      const api = (window as any).Tawk_API;
      if (!api) return;
      if (isDashboard) {
        api.hideWidget?.();
      } else {
        api.showWidget?.();
        api.minimize?.();
      }
    };

    const tawkAPI = (window as any).Tawk_API;
    if (tawkAPI) {
      applyVisibility();
    }

    (window as any).Tawk_API = (window as any).Tawk_API || {};
    const existingOnLoad = (window as any).Tawk_API.onLoad;
    (window as any).Tawk_API.onLoad = function () {
      if (typeof existingOnLoad === "function") existingOnLoad();
      applyVisibility();
    };

    const existingOnMaximized = (window as any).Tawk_API.onChatMaximized;
    (window as any).Tawk_API.onChatMaximized = function () {
      if (typeof existingOnMaximized === "function") existingOnMaximized();
      if (!isDashboard) {
        (window as any).Tawk_API.minimize?.();
      }
    };

    // Poll briefly in case the widget script loads slightly after this runs,
    // and force-minimize during the poll window too (catches early auto-popups)
    const pollInterval = setInterval(() => {
      const api = (window as any).Tawk_API;
      if (api?.hideWidget) {
        applyVisibility();
        if (!isDashboard) {
          api.minimize?.();
        }
        clearInterval(pollInterval);
      }
    }, 500);

    const stopPoll = setTimeout(() => clearInterval(pollInterval), 15000);

    return () => {
      clearInterval(pollInterval);
      clearTimeout(stopPoll);
    };
  }, [isDashboard, pathname]);

  return null;
}
